import { SortDirection } from "@/types/apis";
import { useCurrentUserProfile } from "./current-user-profile.hook";
import { useSearchApplications } from "./search-applications.hook";

export const useApplicationList = () => {
  const { data: userProfile } = useCurrentUserProfile();

  const {
    data: applicationsForRegular,
    isLoading: isLoadingApplicationsForRegular,
    isError: isErrorApplicationsForRegular,
  } = useSearchApplications({
    companyId: userProfile?.companyId || "",
    editionTypes: ["REGULAR"],
    size: 1,
    sort: [
      { field: "edition.year", direction: SortDirection.DESC },
      { field: "createdDate", direction: SortDirection.DESC },
    ],
  });

  const {
    data: applicationsForAdhoc,
    isLoading: isLoadingApplicationsForAdhoc,
    isError: isErrorApplicationsForAdhoc,
  } = useSearchApplications({
    companyId: userProfile?.companyId || "",
    editionTypes: ["ADHOC"],
    size: 3,
    sort: [
      { field: "edition.year", direction: SortDirection.DESC },
      { field: "createdDate", direction: SortDirection.DESC },
    ],
  });

  const isLoading =
    isLoadingApplicationsForRegular || isLoadingApplicationsForAdhoc;

  const isError = isErrorApplicationsForRegular || isErrorApplicationsForAdhoc;

  const applications = [
    ...(applicationsForRegular?.content || []),
    ...(applicationsForAdhoc?.content || []),
  ];

  return {
    applications,
    isLoading,
    isError,
  };
};
